var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"size":"regular","type":"primary","loading":_vm.isLoading,"text":_vm.buttonText},on:{"click":function($event){return _vm.startRegistration()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }